















import Vue from "vue";
import Component from "vue-class-component";
@Component
export default class BottomNav extends Vue {
    selected = 1;
    
    created():void {
        if(this.$route.path === '/log') this.selected = 1;
        if(this.$route.path === '/projects') this.selected = 2;
        if(this.$route.path === '/stats') this.selected = 3;
    }
    select(index: number):void {
        this.selected = index;
        
      
        if(this.selected === 1 && this.$route.path !== '/log') {
            this.$router.push("/log");
        }
        if(this.selected === 2 && this.$route.path !== '/projects') {
            this.$router.push("/projects");
        }
        if(this.selected === 3 && this.$route.path !== '/stats' ) {
            this.$router.push("/stats");
        }
    }
}
